import React from 'react';
import Page from '../components/Page';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Spinner,
} from 'reactstrap';
import axios from '../utils/posAxios';
import StorageService from '../services/StorageService';
import {
  MdCameraAlt,
  MdFace,
  MdDone,
  MdClear,
  MdCreate,
  MdAdd,
} from 'react-icons/md';
import { BsPlusSquareFill } from 'react-icons/bs';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { Redirect } from 'react-router';
import classnames from 'classnames';
//import PosShippingForm from 'components/PosShippingForm';
import { IconContext } from 'react-icons/lib';
import PosPromoTable from './PosPromoTable';
import { array } from 'prop-types';

class PosShippingForm extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      isEdit: false,
      isGlobal: true,
      id: '',
      name: '',
      shipping_code: '',
      location: '',
      shipping_type: '',
      country: '',
      fee: '',
      free_value: '0',
      required: 0,
      fee_type: '',
      compare_value: '',
      shipping_id: '',
      shippingList: [],
      store_id: '',
      ecart_country: [],
    };
  }

  componentDidMount() {
    this.Shipping();
    if (this.props.data.isGlobal) {
      if (this.props.data.isEdit) {
        let id = this.props.data.selectedId;
        const data = this.props.data.shippingList.find(e => e.id === id);
        this.setState({
          id: id,
          name: data.name,
          shipping_code: data.shipping_code,
          location: data.location,
          shipping_type: data.shipping_type,
          // country: data.country,
          fee: data.fee,
          free_value: data.free_value,
          compare_value: data.compare_value,
          required: data.required,
          fee_type: data.fee_type,
          isEdit: true,
          isGlobal: this.props.data.isGlobal,
        });
      }
    } else {
      this.setState({
        store_id: this.props.data.store_id,
        isGlobal: this.props.data.isGlobal,
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  static getDerivedStateFromProps(props, state) {
    if (props.data.ecart_country !== state.ecart_country) {
      return {
        ecart_country: props.data.ecart_country,
      };
    }

    return null;
  }

  Shipping = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    };

    axios
      .post(url + ':3001/v2/shipping', data)
      .then(response => {
        let result = [...response.data.data];
        const storeShipping = this.props.data.shippingList;
        console.log(result);
        // let ShippingOp = result.data.filter(
        //   x =>
        //     !storeShipping.some(
        //       y =>
        //         y.id === x.id
        //     ),
        // );

        let ShippingOp_prev = [
          ...storeShipping
            .reduce((r, o) => {
              const key = o.id;

              const item =
                r.get(key) ||
                Object.assign({}, o, {
                  id: o.id,
                  name: o.name,
                  country: [],
                  allmatch: false,
                });

              item.country.push(o.country);
              if (item.country.length == this.state.ecart_country.length) {
                item.allmatch = true;
              }
              return r.set(key, item);
            }, new Map())
            .values(),
        ];

        let ShippingOp = [];

        for (let i of result) {
          let allmatch = false;
          for (let j of ShippingOp_prev) {
            if (i.id == j.id) {
              i.country = j.country;
              if (j.allmatch == true) {
                allmatch = true;
              }
            }
          }
          if (allmatch == false) {
            ShippingOp.push(i);
          }
        }

        let ShippingOp_next = [];

        for (let i of ShippingOp) {
          if (i.hasOwnProperty('country')) {
            let array1 = this.state.ecart_country.filter(
              val => !i.country.includes(val),
            );
            i.country = array1;
          } else {
            i.country = this.state.ecart_country;
          }
          ShippingOp_next.push(i);

          // if (i.allmatch == false) {
          //   let array1 = this.state.ecart_country.filter(
          //     val => !i.country.includes(val),
          //   );
          //   i.country = array1;
          //   ShippingOp_next.push(i);
          // }
        }

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          this.setState({ shippingList: ShippingOp_next });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  changeHandler = e => {
    let { name, value } = e.target;
    if (name === 'fee') {
      if (value.includes('.')) {
        let decimal = value.split('.')[1];
        if (decimal.length > 2) {
          value = value.slice(0, -1);
        }
      }
    }

    if (name === 'shipping_code') {
      value = value.replace(/\s/g, '');
    }

    this.setState({
      [name]: value,
    });
  };

  checkHandler = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: !this.state[name],
      free_value: !this.state[name] == true ? '0' : this.state.free_value,
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    if (this.state.isGlobal) {
      if (!this.state.isEdit) {
        this.create(user, comp, url);
      } else {
        this.update(user, comp, url);
      }
    } else {
      this.add(user, comp, url);
    }
  };

  create(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      name: this.state.name,
      shipping_code: this.state.shipping_code,
      location: this.state.location,
      shipping_type: this.state.shipping_type,
      // country: this.state.country,
      fee: this.state.fee,
      free_value: this.state.free_value,
      required: this.state.required,
      fee_type: this.state.fee_type,
      created_by: user.email,
    };

    axios
      .post(url + ':3001/v4/shipping/create', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'New Shipping added successfully.',
          'success',
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  }

  update(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      id: this.state.id,
      company_id: comp.CompanyID,
      name: this.state.name,
      shipping_code: this.state.shipping_code,
      location: this.state.location,
      shipping_type: this.state.shipping_type,
      // country: this.state.country,
      fee: this.state.fee,
      free_value: this.state.free_value,
      required: this.state.required,
      fee_type: this.state.fee_type,
      update_by: user.email,
    };

    axios
      .post(url + ':3001/v4/shipping/update', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'Shipping details updated successfully.',
          'success', //'error' post when return error
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  }

  add(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      shipping_id: this.state.shipping_id,
      country: this.state.country,
      added_by: user.email,
    };

    axios
      .post(url + ':3001/v2/store/shipping/add', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'New Shipping added successfully.',
          'success',
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  }

  render() {
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>
          Shipping {this.state.isGlobal ? 'Details' : 'List'}
        </ModalHeader>
        <ModalBody>
          {this.state.isGlobal ? (
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label>Name</Label>
                  <Input
                    type="text"
                    name="name"
                    value={this.state.name}
                    onChange={this.changeHandler}
                    required
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Shipping Code</Label>
                  <Input
                    type="text"
                    name="shipping_code"
                    value={this.state.shipping_code}
                    onChange={this.changeHandler}
                    required
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Location</Label>
                  <Input
                    type="select"
                    name="location"
                    value={this.state.location}
                    onChange={this.changeHandler}
                    required
                  >
                    <option value=""></option>
                    <option value="LOCAL">LOCAL</option>
                  </Input>
                </FormGroup>
                <FormGroup>
                  <Label>Shipping Type</Label>
                  <Input
                    type="select"
                    name="shipping_type"
                    value={this.state.shipping_type}
                    onChange={this.changeHandler}
                    required
                  >
                    <option value=""></option>
                    <option value="MANUAL">MANUAL</option>
                  </Input>
                </FormGroup>
                {/* <FormGroup>
                  <Label>Country</Label>
                  <Input
                    type="select"
                    name="country"
                    value={this.state.country}
                    onChange={this.changeHandler}
                    required
                  >
                    <option value=""></option>
                    <option value="Singapore">Singapore</option>
                    <option value="Malaysia">Malaysia</option>
                    <option value="Indonesia">Indonesia</option>
                    <option value="Thailand">Thailand</option>
                    <option value="Australia">Australia</option>
                    <option value="Others">Others</option>
                  </Input>
                </FormGroup> */}
                <FormGroup>
                  <Label>Fee</Label>
                  <Input
                    type="text"
                    name="fee"
                    value={this.state.fee}
                    onChange={this.changeHandler}
                    required
                  />
                </FormGroup>
                <FormGroup check>
                  <Label>
                    <Input
                      type="checkbox"
                      name="required"
                      checked={this.state.required}
                      onChange={this.checkHandler}
                    />
                    Auto Include
                  </Label>
                </FormGroup>
                <FormGroup>
                  <Label>Free Value</Label>
                  <Input
                    type="text"
                    name="free_value"
                    value={this.state.free_value}
                    onChange={this.changeHandler}
                    disabled={this.state.required}
                    required
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Fee Type</Label>
                  <Input
                    type="select"
                    name="fee_type"
                    value={this.state.fee_type}
                    onChange={this.changeHandler}
                    required
                  >
                    <option></option>
                    <option value="FIXED">FIXED</option>
                    <option value="PERCENT">PERCENT</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label>Shipping Type</Label>
                  <Input
                    type="select"
                    name="shipping_id"
                    onChange={this.changeHandler}
                    required
                  >
                    <option></option>
                    {this.state.shippingList &&
                      this.state.shippingList.map(item => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        );
                      })}
                  </Input>
                </FormGroup>
                <FormGroup>
                  <Label>Country (Options depend on Shipping Type)</Label>
                  <Input
                    type="select"
                    name="country"
                    onChange={this.changeHandler}
                    required
                  >
                    <option></option>
                    {this.state.shipping_id &&
                      this.state.shippingList
                        .find(x => x.id == this.state.shipping_id)
                        .country.map(item => {
                          return (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          );
                        })}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    );
  }
}

export default PosShippingForm;
